<template><div><dt-notice kind="warning" title="Use DtText over CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Reach for the <a href="/components/text" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtText</a> component before considering any typography utility.
</dt-notice>
<h2 id="normal" tabindex="-1" class="d-docsite--header-2">Normal <a class="header-anchor d-link d-docsite--link d-link" href="#normal" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-fs-normal</code> to change an element's font-style.</p>
<code-example source-code='&lt;p class=&quot;d-fs-normal&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-fs-normal">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="italics" tabindex="-1" class="d-docsite--header-2">Italics <a class="header-anchor d-link d-docsite--link d-link" href="#italics" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-fs-italic</code> to change an element's font-style.</p>
<code-example source-code='&lt;p class=&quot;d-fs-italic&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-fs-italic">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="no-italics" tabindex="-1" class="d-docsite--header-2">No Italics <a class="header-anchor d-link d-docsite--link d-link" href="#no-italics" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-fs-none</code> to remove an element's font-style.</p>
<code-example source-code='&lt;p class=&quot;d-fs-none&quot;&gt;The quick brown fox jumps over the lazy dog.&lt;/p&gt;'>
<p class="d-fs-none">The quick brown fox jumps over the lazy dog.</p>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in style">
        <th scope="row" class="d-code--sm d-docsite-code">.d-fs-{{ i }}</th>
        <td class="d-code--sm">font-style: {{ i }} !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { style } from '@data/type.json';
</script>